import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import moment from 'moment';

import { ADGMResponsiveModal } from 'aurora-components';

import UserDocs from './UserDocs';
import styles from './styles';

const initialState = {
  userType: 'person',
  userInputId: '',
};

function AddBuyerModal(props) {
  const {
    intl,
    locale,
    documents,
    // toggleModal,
    handleModalClose,
    modalTitle,
    userDocsTitle,
    buttonText,
    classes,
    handleAddUser,
    handleFileUpload,
    handleFileRemove,
    FieldComponent,
    addBuyerModal,
    buyerSelected,
  } = props;
  const [formState, setFormState] = useState(initialState);

  useEffect(() => {
    return () => {
      setFormState(initialState);
    };
  }, []);

  const isNonResident = useMemo(() => {
    return buyerSelected?.userType === 'DARI_USER' && true;
  }, [buyerSelected]);

  const handleStateChange = e => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (name, value) => {
    setFormState({
      ...formState,
      [name]: moment(value)
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm:ss'),
    });
  };

  const handleSelect = (name, value) => {
    setFormState(state => ({
      ...state,
      [name]: value?.value || null,
    }));
  };

  const onModalClose = () => {
    setFormState(initialState);
    handleModalClose();
  };

  function handleBtnDisable() {
    if (isNonResident) {
      return documents?.findIndex(doc => doc.type === 'PASSPORT') === -1;
    }
    return false;
  }

  return (
    <ADGMResponsiveModal
      open={addBuyerModal}
      toggleModal={onModalClose}
      onClose={onModalClose}
      title={modalTitle}
      disablePortal
      customClasses={{
        modal: classes.buyerModalPerson,
      }}
    >
      <div>
        <>
          {/* Input fields container */}
          <FieldComponent
            locale={locale}
            intl={intl}
            formState={formState}
            handleStateChange={handleStateChange}
            handleDateChange={handleDateChange}
            handleSelect={handleSelect}
            buyerSelected={buyerSelected}
          />
          {/* Document fields container */}
          <UserDocs
            documents={documents}
            title={userDocsTitle}
            buyerSelected={buyerSelected}
            formState={formState}
            handleFileRemove={handleFileRemove}
            handleUpload={handleFileUpload}
          />
        </>
        <div className={classes.modalFooter}>
          <div className={classes.subPanel}>
            <Button
              className={classNames(classes.mediumButton, classes.addBuyerButton)}
              disabled={handleBtnDisable()}
              onClick={() => handleAddUser()}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </ADGMResponsiveModal>
  );
}

AddBuyerModal.propTypes = {
  classes: PropTypes.object.isRequired,
  buyerSelected: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  modalTitle: PropTypes.node.isRequired,
  userDocsTitle: PropTypes.node.isRequired,
  buttonText: PropTypes.node.isRequired,
  documents: PropTypes.array.isRequired,
  handleAddUser: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  handleFileUpload: PropTypes.func.isRequired,
  handleFileRemove: PropTypes.func.isRequired,
  FieldComponent: PropTypes.node.isRequired,
  addBuyerModal: PropTypes.bool.isRequired,
};

AddBuyerModal.defaultProps = {};

export default withStyles(styles)(AddBuyerModal);
